import React from 'react';
import ReportFrame from '../ReportFrame';

export default class EvaluatorExpenseAnalysisReport extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Evaluator Expense Analysis'
          reportParams={reportParams}
          id='evaluatorexpenseanalysis'
          name='evaluatorexpenseanalysis'
          title='Evaluator Expense Analysis'
        />
      </div>
    );
  }
}
